module.exports = __webpack_public_path__ + "static/media/eric.f2c95339.jpeg";